export default __webpack_public_path__ + "static/media/large-birthday10.557020fd.png";